module.exports = __webpack_public_path__ + "static/media/confirmacion_logoClinicaSegura.e07f30a6.svg";